import React from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'

import { T } from 'components/Translations'
import Button from 'components/Button'

const NoResults = ({ location }) => {
  const noMatches = location.search.match(/filters=matches(?!,)/)
  const to = noMatches ? '/myprofile/matches' : '/browse?filters=matches'

  return (
    <StyledNoResults>
      <T as="h2" label="oops" />
      <div className="img-container" />
      {noMatches ? (
        <T as="p" label="messages/noMoreMembers" />
      ) : (
        <>
          <T as="p" label="messages/noResults1" />
          <T as="p" label="messages/noResults2" />
        </>
      )}

      <Button to={to} color="highlight" size="large" label="sections/findADate" />
    </StyledNoResults>
  )
}

const StyledNoResults = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  margin: 0 auto;
  max-width: 800px;
  text-align: center;
  font-size: 1.6rem;

  .img-container {
    width: 100%;
    height: 50vh;
    background-image: url(${() => require(`assets/noresults/woman${window.devicePixelRatio >= 2 ? '@2x' : ''}.png`)});
    background-position: center top;
    background-repeat: no-repeat;
    background-size: contain;
  }

  h2 {
    margin: 0 auto -6vh;
    color: ${p => p.theme.colors.textSectionTitle};
    font-size: 10vh;
    font-weight: 900;
    text-transform: uppercase;
  }

  p {
    margin: 20px 0 10px;
    & + p {
      margin: 0 0 20px;
    }
  }

  a {
    display: inline-block;
    text-transform: uppercase;
  }
`
export default withRouter(NoResults)
